// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-label[data-v-b2bc14b2]{transition:all .3s;z-index:1;position:relative;display:inline-block}.exc-label--bordered[data-v-b2bc14b2]{border-radius:2.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
